module.exports = __webpack_public_path__ + "img/legacy_8.57d0507e.jpg";